import { FactoryProvider, inject, InjectionToken } from '@angular/core';
import {
  LassiApplication,
  QuickSearchAddressDto,
  QuickSearchAddressPfiDto,
  QuickSearchFeatureDto,
  QuickSearchLgaDto,
  QuickSearchLocalityDto,
  QuickSearchParcelDto,
  QuickSearchParishDto,
  QuickSearchPropertyDto,
  QuickSearchRoadDto,
  QuickSearchSurveyLabelDto,
  QuickSearchSurveyMarkDto,
  QuickSearchTownshipDto,
} from '@core/api/angular';
import { APPLICATION } from '@lassi/config';

export type QuickSearchResult =
  | QuickSearchSurveyMarkDto
  | QuickSearchSurveyLabelDto
  | QuickSearchAddressDto
  | QuickSearchLgaDto
  | QuickSearchParcelDto
  | QuickSearchParishDto
  | QuickSearchPropertyDto
  | QuickSearchRoadDto
  | QuickSearchTownshipDto
  | QuickSearchFeatureDto
  | QuickSearchLocalityDto
  | QuickSearchAddressPfiDto;

export interface IQuickSearchType {
  name: string;
  value: string;
}

const allQuickSearchTypes: IQuickSearchType[] = [
  { name: 'Address', value: 'address' },
  { name: 'LGA', value: 'lga' },
  { name: 'Locality', value: 'locality' },
  { name: 'Feature', value: 'place' },
  { name: 'Parcel', value: 'parcel' },
  { name: 'Parish', value: 'parish' },
  { name: 'Property', value: 'property' },
  { name: 'Road', value: 'road' },
  { name: 'Survey Label', value: 'survey_label' },
  { name: 'Survey Mark', value: 'survey_mark' },
  { name: 'Township', value: 'township' },
];

export const QUICK_SEARCH_TYPE_LIST = new InjectionToken(
  'QUICK_SEARCH_TYPE_LIST',
  {
    factory: () => allQuickSearchTypes,
  },
);
export function provideEmbeddedQuickSearchTypeList(): FactoryProvider {
  return {
    provide: QUICK_SEARCH_TYPE_LIST,
    useFactory: () => {
      const application = inject(APPLICATION);

      let types = allQuickSearchTypes;

      if (application === LassiApplication.SPEAR) {
        types = allQuickSearchTypes.filter((type) =>
          EMBEDDED_SPEAR_MAP_SEARCH_TYPE_NAMES.includes(type.name),
        );
      }

      return types;
    },
  };
}

const EMBEDDED_SPEAR_MAP_SEARCH_TYPE_NAMES = [
  'Address',
  'LGA',
  'Locality',
  'Parcel',
  'Parish',
  'Property',
  'Road',
  'Township',
];
